import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiPhone } = FiIcons;

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50 border-b-2 border-[#826046]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://i.ibb.co/DPLWWytS/logo.jpg" 
              alt="Mr. Shaver Logo" 
              className="h-12 w-12 sm:h-14 sm:w-14 object-cover rounded-full border-2 border-[#826046]"
            />
            <div className="ml-3 hidden sm:block">
              <h1 className="text-lg font-bold text-[#826046]">Mr. Shaver</h1>
              <p className="text-xs text-gray-600">Gents Salon</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors duration-200 hover:text-[#826046] ${
                  location.pathname === item.path 
                    ? 'text-[#826046] border-b-2 border-[#826046] pb-1' 
                    : 'text-gray-700'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <div className="flex items-center space-x-4">
            <a 
              href="tel:+971501656278"
              className="hidden sm:flex items-center bg-[#826046] text-white px-4 py-2 rounded-lg hover:bg-[#6d4d37] transition-colors duration-200"
            >
              <SafeIcon icon={FiPhone} className="w-4 h-4 mr-2" />
              <span className="text-sm font-medium">Call Now</span>
            </a>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="md:hidden p-2 rounded-md text-[#826046] hover:bg-gray-100 transition-colors duration-200"
            >
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-gray-200 absolute w-full left-0 shadow-lg"
          >
            <div className="px-4 py-4 space-y-3">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`block py-3 px-4 rounded-lg transition-colors duration-200 ${
                    location.pathname === item.path
                      ? 'bg-[#826046] text-white'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <a 
                href="tel:+971501656278"
                className="flex items-center justify-center bg-[#826046] text-white py-3 px-4 rounded-lg hover:bg-[#6d4d37] transition-colors duration-200"
              >
                <SafeIcon icon={FiPhone} className="w-4 h-4 mr-2" />
                Call Now: +971 50 165 6278
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;